import dummy from './dummy';

let analytics = null;
if (__ANALYTICS__) {
  analytics = dummy;
} else {
  analytics = dummy;
}

export default analytics;
